module.exports = __webpack_public_path__ + "static/media/twin4resilience-interreg-nwe-vertical.2df3c9fa.png";